import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { RetreatType, LoadingState } from '../../types';
import { retreatTypeService } from '../../services/retreatTypeService';

interface RetreatTypeState extends LoadingState {
  retreatTypes: RetreatType[];
  selectedRetreatType: RetreatType | null;
}

const initialState: RetreatTypeState = {
  retreatTypes: [],
  selectedRetreatType: null,
  isLoading: false,
  error: null,
};

// Async Thunks
export const fetchRetreatTypes = createAsyncThunk(
  'retreatTypes/fetchRetreatTypes',
  async (_, { rejectWithValue }) => {
    try {
      const response = await retreatTypeService.getRetreatTypes();
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch retreat types');
    }
  }
);

const retreatTypeSlice = createSlice({
  name: 'retreatTypes',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    setSelectedRetreatType: (state, action: PayloadAction<RetreatType | null>) => {
      state.selectedRetreatType = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Retreat Types
      .addCase(fetchRetreatTypes.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchRetreatTypes.fulfilled, (state, action) => {
        state.isLoading = false;
        state.retreatTypes = action.payload;
      })
      .addCase(fetchRetreatTypes.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearError, setSelectedRetreatType } = retreatTypeSlice.actions;
export default retreatTypeSlice.reducer;
